// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"PopupModal_tooltipContainer__2vECT","content":"PopupModal_content__3Kikb","bigFont":"PopupModal_bigFont__3MZbI"};